/* eslint-disable brace-style */
/* eslint-disable security/detect-object-injection */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
//import Block, { BlockProps } from './Block'
import { useAppState } from '@bees-web/core/shared/contexts'

import { useBlockSchema, useReadyToFetch } from '../hooks'

// eslint-disable-next-line import/no-cycle
import Block, { BlockProps } from './BlockOptimized'
import ErrorStatement from './ErrorStatement'

const FallbackBlock = ({ template }: BlockProps) => {
  const defaultBlock = {
    ...template,
    deferred: null,
  }
  return <Block template={defaultBlock} />
}

const AsyncBlock = ({ template }: BlockProps) => {
  const { block, isLoading, error } = useBlockSchema(template)

  if (isLoading || !block) return <FallbackBlock template={template} />
  if (error)
    return <ErrorStatement title='Deferred load error'>{error.message}</ErrorStatement>

  return (
    <Block
      template={{
        ...template,
        blocks: block.blocks,
        deferred: null,
      }}
    />
  )
}

const DeferredBlock = (props: BlockProps) => {
  const {
    template: { waitForState = [] },
  } = props

  const { state } = useAppState()

  const readyToFetch = useReadyToFetch(waitForState, state)

  return readyToFetch ? <AsyncBlock {...props} /> : <FallbackBlock {...props} />
}

export default DeferredBlock
